module.exports = __webpack_public_path__ + "static/media/hard-drive.a27fc279.svg";